export default "__VITE_ASSET__BMusiIyw__"